import React, { useEffect, useState } from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { toast } from "react-toastify";
import { useSignalR } from "../../context/SignalRContext.js";

export default function Testing2() {
  const { connectToDeal } = useSignalR();
  const [buyerConnected, setBuyerConnected] = useState(false);
  const contractId = 1014; // Hardcoded contract ID

  useEffect(() => {
    const connect = async () => {
      try {
        console.log("🔄 Connecting to deal:", contractId);
        await connectToDeal(contractId);
        console.log("✅ Successfully connected to deal:", contractId);
        toast.success(`Connected to deal ${contractId}`);
        setBuyerConnected(true);
      } catch (err) {
        console.error("❌ Connection failed:", err);
        toast.error("Unable to connect to deal");
      }
    };

    connect();
  }, []);

  return (
    <Container sx={{ position: "relative", mt: 6 }}>
      <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
        Testing Step 0 - Buyer Connection
      </Typography>

      {!buyerConnected ? (
        <Typography sx={{ textAlign: "center", color: "blue" }}>
          🔄 Connecting to deal {contractId}... Please wait
        </Typography>
      ) : (
        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#04ba7d" }}
            size="large"
            onClick={() => alert("Continue to Step 2!")}
          >
            Continue
          </Button>
        </Box>
      )}
    </Container>
  );
}